import {ConverterPage, Parameter} from "@softvision/webpdf-wsclient-9-typescript/lib/generated-sources";
import FunctionHelper from "../helper/FunctionHelper";
import FormatEnum from "./FormatEnum";
import OrientationEnum from "./OrientationEnum";
import LengthUnit from "../units/LengthUnit";

export class PortalPage extends ConverterPage implements Parameter {
	public format?: string;
	public orientation?: OrientationEnum;
	public unit?: LengthUnit;

	constructor(data: any) {
		super(data);

		this.format = FunctionHelper.exists(data?.format) ? data.format : FormatEnum.ORIGINAL;
		this.orientation = FunctionHelper.exists(data?.orientation) ? data.orientation : OrientationEnum.VERTICAL;
		this.unit = FunctionHelper.exists(data?.unit) ? data.unit : LengthUnit.MILLIMETER;
	}

	public static getFormatDefault(): string {
		return FormatEnum.ORIGINAL;
	}

	public static getOrientationDefault(): OrientationEnum {
		return OrientationEnum.VERTICAL;
	}

	public static getUnitDefault(): LengthUnit {
		return LengthUnit.MILLIMETER;
	}

	public static fromJson(data: any): PortalPage {
		if (!FunctionHelper.exists(data)) {
			return data;
		}

		return new PortalPage(data);
	}

	public toJson(): any {
		return {
			...super.toJson(),
			'format': this.format,
			'orientation': this.orientation,
			'unit': this.unit
		};
	}

	public clone(): PortalPage {
		return PortalPage.fromJson(this.toJson());
	}
}